        // 1. 选项卡切换逻辑
        const tabBtns = document.querySelectorAll('.tab-btn');
        const tabContents = document.querySelectorAll('.tab-content');

        tabBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                tabBtns.forEach(b => b.classList.remove('active'));
                tabContents.forEach(c => c.classList.remove('active'));
                btn.classList.add('active');
                const tabId = btn.getAttribute('data-tab');
                document.getElementById(tabId).classList.add('active');
            });
        });

        // 2. 滚动渐入动画
        const fadeElements = document.querySelectorAll('.fade-in');

        const checkFade = () => {
            fadeElements.forEach(element => {
                const elementTop = element.getBoundingClientRect().top;
                const elementBottom = element.getBoundingClientRect().bottom;
                const isVisible = (elementTop < window.innerHeight - 100) && (elementBottom > 0);
                
                if (isVisible) {
                    element.classList.add('active');
                }
            });
        };

        window.addEventListener('load', checkFade);
        window.addEventListener('scroll', checkFade);

        // 3. FAQ折叠逻辑
        //const faqQuestions = document.querySelectorAll('.faq-question');

       // faqQuestions.forEach(question => {
           // question.addEventListener('click', () => {
               // const answer = question.nextElementSibling;
                //const icon = question.querySelector('.faq-icon');
                
              //  answer.classList.toggle('active');
               // icon.classList.toggle('active');
            //});
       // });


        // 5. 平滑滚动（锚点链接）
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                
                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop - 100,
                        behavior: 'smooth'
                    });
                }
            });
        });



